'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoveApi = require('../lib/CoveApi');

var _CoveApi2 = _interopRequireDefault(_CoveApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Item API
 */
var Vehicle = function (_CoveAPI) {
  (0, _inherits3.default)(Vehicle, _CoveAPI);

  /**
   * Creates a new Vehicle API Client
   * @param {string} host
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function Vehicle(host, environment, auth) {
    (0, _classCallCheck3.default)(this, Vehicle);
    return (0, _possibleConstructorReturn3.default)(this, (Vehicle.__proto__ || (0, _getPrototypeOf2.default)(Vehicle)).call(this, host, 'vehicle/v1', environment, auth));
  }

  /**
   * Find and save a match of this custom vehicle
   *
   * @param {*} body
   */


  (0, _createClass3.default)(Vehicle, [{
    key: 'match',
    value: function match(params, body) {
      return this.apiClient.fetch('POST', 'match', params, body);
    }

    /**
     * Query vehicle database will return data in the form of:
     *  {
     *    makes: [],
     *    models: [],
     *    submodels: [],
     *    bodyTypes: [],
     *    engineSizes: [],
     *    transmissions: [],
     *    importStatuses: []
     *  }
     * @param {*} params (year, make, model, submodel)
     */

  }, {
    key: 'queryV2',
    value: function queryV2(params) {
      return this.apiClient.fetch('GET', 'queryV2', params);
    }
    /**
     * Query item database based on the given parameters
     * @param {string} [year]
     * @param {string} [make]
     * @param {string} [model]
     * @param {string} [sub_model]
     */

  }, {
    key: 'query',
    value: function query(year, make, model, sub_model) {
      var params = {};

      if (year) {
        params.year = year;
      }

      if (make) {
        params.make = make;
      }

      if (model) {
        params.model = model;
      }

      if (sub_model) {
        params.sub_model = sub_model;
      }

      return this.apiClient.fetch('GET', 'query', params);
    }
  }, {
    key: 'queryMultiple',
    value: function queryMultiple(queryParams) {
      return this.apiClient.fetch('GET', 'queryMultiple', queryParams);
    }

    /**
     * Queries using a query object. Useful for the item dropdown
     * @param {*} query - Query object e.g. { make: "Toyota", family: "Corola" }
     */

  }, {
    key: 'queryByObject',
    value: function queryByObject(queryParams) {
      return this.apiClient.fetch('GET', 'query', queryParams);
    }

    /**
     * Looks up the user agent string and returns the result
     * @param {string} registration
     */

  }, {
    key: 'queryByRegistration',
    value: function queryByRegistration(registration) {
      return this.apiClient.fetch('GET', 'query', { registration: registration });
    }

    /**
     * Looks up the user agent string and returns the result
     * @param {string} redbookCode
     */

  }, {
    key: 'queryByRedbook',
    value: function queryByRedbook(redbookCode, registration) {
      return this.apiClient.fetch('GET', 'query', { redbookCode: redbookCode, registration: registration });
    }
  }]);
  return Vehicle;
}(_CoveApi2.default);

exports.default = Vehicle;